import styled from 'astroturf/react';

const Bar = styled('div')`
  float: left;
  height: 3px;
`;

const TriangleDiv = styled('div')`
  position: relative;
  right: 0;
  height: 7px;
`;

const Triangle = styled('div')`
  position: absolute;
  right: -8px;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid black;
`;

export default {
  Bar,
  TriangleDiv,
  Triangle,
};
